import { Box, Button, Grid } from "@mui/material";
import { t } from "i18next";
import type { FC } from "react";
import type { ButtonTemplateSettings } from "../../email-design/types/email-button-settings";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { emailButtonStyles } from "../../lexical-email-moment/email-button-styles";
import { HoverBadge } from "../hover-badge";
import type { PreviewProps } from "./types";

export const ButtonsPreview: FC<PreviewProps> = (props) => {
  const { button_settings } = props.data;

  return (
    <Grid container border="1px solid transparent" width="100%" columns={2}>
      {button_settings?.primary_button && (
        <ButtonPreview
          button={button_settings.primary_button}
          label={t("Primary Button")}
          name={"primary_button"}
          {...props}
        />
      )}
      {button_settings?.secondary_button && (
        <ButtonPreview
          button={button_settings.secondary_button}
          label={t("Secondary Button")}
          name="secondary_button"
          {...props}
        />
      )}
    </Grid>
  );
};

const ButtonPreview: FC<
  {
    button: Partial<ButtonTemplateSettings>;
    label: string;
    name: string;
  } & PreviewProps
> = ({ button, label, ...props }) => (
  <Grid>
    <ConditionalWrapper
      condition={props.badgeProps !== undefined}
      wrapper={(children) => (
        <HoverBadge badgeContent={label} name={props.name} {...props.badgeProps}>
          {children}
        </HoverBadge>
      )}
    >
      <Box p={2}>
        <Button
          data-analytics-id="email-design-button-preview"
          variant="contained"
          color="primary"
          sx={{ ...emailButtonStyles(button), ":hover": emailButtonStyles(button) }}
        >
          {label}
        </Button>
      </Box>
    </ConditionalWrapper>
  </Grid>
);
